const bannerToolNode = (data) => {
  return {
    type: 'banner',
    id: 'bannernode',
    content: data.toolData,
  };
};

export { bannerToolNode };
